var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import i18next from "i18next";
import { computed, makeObservable } from "mobx";
import isDefined from "../Core/isDefined";
import ConstantColorMap from "../Map/ColorMap/ConstantColorMap";
import ContinuousColorMap from "../Map/ColorMap/ContinuousColorMap";
import DiscreteColorMap from "../Map/ColorMap/DiscreteColorMap";
import EnumColorMap from "../Map/ColorMap/EnumColorMap";
import createStratumInstance from "../Models/Definition/createStratumInstance";
import LoadableStratum from "../Models/Definition/LoadableStratum";
import LegendTraits, { LegendItemTraits } from "../Traits/TraitsClasses/LegendTraits";
export let ColorStyleLegend = (_class = class ColorStyleLegend extends LoadableStratum(LegendTraits) {
  /**
   *
   * @param catalogItem
   * @param index index of column in catalogItem (if -1 or undefined, then default style will be used)
   */
  constructor(catalogItem) {
    let legendItemOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    this.catalogItem = catalogItem;
    this.legendItemOverrides = legendItemOverrides;
    makeObservable(this);
  }
  duplicateLoadableStratum(newModel) {
    return new ColorStyleLegend(newModel);
  }
  get tableStyle() {
    return this.catalogItem.activeTableStyle;
  }

  // Keep these here until we deprecate LegendTraits in TableColorStyleTraits
  // See https://github.com/TerriaJS/terriajs/issues/6356
  get oldLegendTraits() {
    return this.tableStyle.colorTraits.legend;
  }
  get url() {
    return this.oldLegendTraits.url;
  }
  get imageScaling() {
    return this.oldLegendTraits.imageScaling;
  }
  get urlMimeType() {
    return this.oldLegendTraits.urlMimeType;
  }
  get backgroundColor() {
    return this.oldLegendTraits.backgroundColor;
  }

  /** Add column title as legend title if showing a Discrete or Enum ColorMap */
  get title() {
    var _this$tableStyle$colo, _this$tableStyle$colo2;
    if (this.oldLegendTraits.title) return this.oldLegendTraits.title;
    if (this.tableStyle.colorMap instanceof ContinuousColorMap || this.tableStyle.colorMap instanceof DiscreteColorMap || this.tableStyle.colorMap instanceof EnumColorMap) return (_this$tableStyle$colo = (_this$tableStyle$colo2 = this.tableStyle.colorColumn) === null || _this$tableStyle$colo2 === void 0 ? void 0 : _this$tableStyle$colo2.title) !== null && _this$tableStyle$colo !== void 0 ? _this$tableStyle$colo : this.tableStyle.title;
  }
  get items() {
    // This is a bit dodgy - but should be fine until we deprecate LegendTraits in TableColorStyleTraits
    if (this.oldLegendTraits.items && this.oldLegendTraits.items.length > 0) return this.oldLegendTraits.traits.items.toJson(this.oldLegendTraits.items);
    let items = [];
    const colorMap = this.tableStyle.colorMap;
    if (colorMap instanceof DiscreteColorMap) {
      items = this._createLegendItemsFromDiscreteColorMap(this.tableStyle, colorMap, this.legendItemOverrides);
    } else if (colorMap instanceof ContinuousColorMap) {
      items = this._createLegendItemsFromContinuousColorMap(this.tableStyle, colorMap, this.legendItemOverrides);
    } else if (colorMap instanceof EnumColorMap) {
      items = this._createLegendItemsFromEnumColorMap(this.tableStyle, colorMap, this.legendItemOverrides);
    } else if (colorMap instanceof ConstantColorMap) {
      items = this._createLegendItemsFromConstantColorMap(this.tableStyle, colorMap, this.legendItemOverrides);
    }
    return items;
  }
  _createLegendItemsFromContinuousColorMap(style, colorMap, legendItemOverrides) {
    const colorColumn = style.colorColumn;
    const nullBin = colorColumn && colorColumn.valuesAsNumbers.numberOfValidNumbers < colorColumn.valuesAsNumbers.values.length ? [createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
      color: style.colorTraits.nullColor || "rgba(0, 0, 0, 0)",
      addSpacingAbove: true,
      title: style.colorTraits.nullLabel || i18next.t("models.tableData.legendNullLabel")
    }))] : [];
    const outlierBin = style.tableColorMap.outlierColor ? [createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
      color: style.tableColorMap.outlierColor.toCssColorString(),
      addSpacingAbove: true,
      title: style.colorTraits.outlierLabel || i18next.t("models.tableData.legendZFilterLabel")
    }))] : [];
    return new Array(this.tableStyle.colorTraits.legendTicks).fill(0).map((_, i) => {
      // Use maxValue for last value so we don't get funky JS precision
      const value = i === this.tableStyle.colorTraits.legendTicks - 1 ? colorMap.maxValue : colorMap.minValue + (colorMap.maxValue - colorMap.minValue) * (i / (this.tableStyle.colorTraits.legendTicks - 1));
      return createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
        color: colorMap.mapValueToColor(value).toCssColorString(),
        title: this._formatValue(value, this.tableStyle.numberFormatOptions)
      }));
    }).reverse().concat(nullBin, outlierBin);
  }
  _createLegendItemsFromDiscreteColorMap(style, colorMap, legendItemOverrides) {
    const colorColumn = style.colorColumn;
    const minimum = colorColumn && colorColumn.valuesAsNumbers.minimum !== undefined ? colorColumn.valuesAsNumbers.minimum : 0.0;
    const nullBin = colorColumn && colorColumn.valuesAsNumbers.numberOfValidNumbers < colorColumn.valuesAsNumbers.values.length ? [createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
      color: style.colorTraits.nullColor || "rgba(0, 0, 0, 0)",
      addSpacingAbove: true,
      title: style.colorTraits.nullLabel || "(No value)"
    }))] : [];
    return colorMap.maximums.map((maximum, i) => {
      const isBottom = i === 0;
      const formattedMin = isBottom ? this._formatValue(minimum, this.tableStyle.numberFormatOptions) : this._formatValue(colorMap.maximums[i - 1], this.tableStyle.numberFormatOptions);
      const formattedMax = this._formatValue(maximum, this.tableStyle.numberFormatOptions);
      return createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
        color: colorMap.colors[i].toCssColorString(),
        title: "".concat(formattedMin, " to ").concat(formattedMax)
        // titleBelow: isBottom ? minimum.toString() : undefined, // TODO: format value
        // titleAbove: maximum.toString() // TODO: format value
      }));
    }).reverse().concat(nullBin);
  }
  _createLegendItemsFromEnumColorMap(style, colorMap, legendItemOverrides) {
    const colorColumn = style.colorColumn;
    // Show null bin if data has null values - or if EnumColorMap doesn't have enough colors to show all values
    const nullBin = colorColumn && (colorColumn.uniqueValues.numberOfNulls > 0 || colorColumn.uniqueValues.values.length > colorMap.values.length) ? [createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
      color: style.colorTraits.nullColor || "rgba(0, 0, 0, 0)",
      addSpacingAbove: true,
      title: style.colorTraits.nullLabel || "(No value)"
    }))] : [];

    // Aggregate colours (don't show multiple legend items for the same colour)
    const colorMapValues = colorMap.values.reduce((prev, current, i) => {
      const cssCol = colorMap.colors[i].toCssColorString();
      if (isDefined(prev[cssCol])) {
        prev[cssCol].push(current);
      } else {
        prev[cssCol] = [current];
      }
      return prev;
    }, {});
    return Object.entries(colorMapValues).map(_ref => {
      let [color, multipleTitles] = _ref;
      return multipleTitles.length > 1 ? createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
        multipleTitles,
        color
      })) : createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
        title: multipleTitles[0],
        color
      }));
    }).concat(nullBin);
  }
  _createLegendItemsFromConstantColorMap(_style, colorMap, legendItemOverrides) {
    return [createStratumInstance(LegendItemTraits, _objectSpread(_objectSpread({}, legendItemOverrides), {}, {
      color: colorMap.color.toCssColorString(),
      title: colorMap.title
    }))];
  }
  _formatValue(value, format) {
    return (format !== null && format !== void 0 && format.maximumFractionDigits ? value : Math.round(value)).toLocaleString(undefined, format);
  }
}, _applyDecoratedDescriptor(_class.prototype, "tableStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tableStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "oldLegendTraits", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "oldLegendTraits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "url", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "url"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageScaling", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageScaling"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "urlMimeType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "urlMimeType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "backgroundColor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "backgroundColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "items", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "items"), _class.prototype), _class);